import type { Heading } from 'mdast';

import type { State } from '../state';

export function heading(state: State, node: Heading): void {
	const nodeType = state.schema.nodes.heading;
	if (!nodeType) {
		// Gracefully degrade: render heading content as a paragraph when schema
		// has no heading node. This preserves text content without crashing.
		state.openNode(state.schema.nodes.paragraph);
		state.parseTokens(node.children);
		state.closeNode();
		return;
	}
	state.openNode(nodeType, { level: node.depth });
	state.parseTokens(node.children);
	state.closeNode();
}
